var config = {
  BASE_URL: process.env.VUE_APP_BASE_URL,
  TRANSPORT_URL: process.env.VUE_APP_TRANSPORT_URL,
  AMBULANCE_URL: process.env.VUE_APP_AMBULANCE_URL,
  BLOODBANK_URL: process.env.VUE_APP_BLOODBANK_URL,
  PHARMACY_URL: process.env.VUE_APP_PHARMACY_URL,
  DIAGNOSTICS_URL: process.env.VUE_APP_DIAGNOSTICS_URL,
  DOCSMART_URL: process.env.VUE_APP_DOCSMART_URL,
  COREAPP_DOCSMART_URL: process.env.VUE_APP_CORE_APP_DOCSMART_URL,
  ACCOUNTS_URL: process.env.VUE_APP_ACCOUNTS_URL,
  VENDORS_URL: process.env.VUE_APP_VENDORS_URL,
  NEWS_ENABLED: process.env.VUE_APP_NEWS_ENABLED === "true",
  UNDER_DEVELOPMENT: process.env.VUE_APP_UNDER_DEVELOPMENT
    ? process.env.VUE_APP_UNDER_DEVELOPMENT.split(",")
    : [],
  SUBSCRIPTIONS_URL: process.env.VUE_APP_SUBSCRIPTIONS_URL,
};

module.exports = config;
